export enum Right {
  // agents
  ManageAgents = "agents.manageAgents",
  ManageTeams = "agents.manageTeams",
  SeeOtherAgentsTeams = "agents.seeOtherAgentsTeams",
  ImportLiveChatAgents = "agents.importLiveChatAgents",
  ManageOwnSignature = "agents.manageOwnSignature",

  // tickets
  CreateTickets = "tickets.createTickets",
  ManageTickets = "tickets.manageTickets",
  DeleteTickets = "tickets.deleteTickets",
  CreateCustomViews = "tickets.createCustomViews",
  SeeCustomViews = "tickets.seeCustomViews",

  // settings
  SeeSettings = "settings.access",
  ManageSharedCannedResponses = "settings.manageSharedCannedResponses",
  ManageSharedTags = "settings.manageSharedTags",
  ManageCompanyName = "settings.manageCompanyName",
  ManageNotifications = "settings.manageNotifications",
  ManageCustomMailboxes = "settings.manageCustomMailboxes",
  ImportDataFromLiveChat = "settings.importDataFromLiveChat",

  // subscription
  ManageSubscription = "subscription.manageSubscription",

  // reports
  SeeReports = "reports.access",
  ExportReports = "reports.exportReports",
}

export type IRights = Partial<{ [key in Right]: boolean }>;
